import { Redirect } from "react-router-dom";

const Home = () => <Redirect to='/series'/>

export default Home;
